// Iter 56 — Validated Knowledge Prompts: wording helpers for the knowledge_context
// summary the backend stores next to every workspace-bound AI deliverable / memo.

export const KNOWLEDGE_NOTE = "This narrative prioritizes validated knowledge where available.";
export const KNOWLEDGE_HINT =
  "Validated workspace knowledge (business rules, disposition decisions, field lineage, screen walkthroughs, evidence batches) is added to the prompt automatically, ahead of anything proposed or AI-inferred.";
export const UNVALIDATED_TOGGLE_LABEL = "Also include proposed (unvalidated) business rules — clearly labelled PROPOSED";

const n = (kc, key) => Number(kc?.[key]?.included || 0);

/** One-line grounding summary for a stored knowledge_context, or null when none was recorded. */
export function knowledgeSummary(kc) {
  if (!kc || typeof kc !== "object") return null;
  const parts = [];
  const rules = n(kc, "validated_rules");
  const disp = n(kc, "validated_dispositions");
  const fields = n(kc, "field_lineage");
  const screens = n(kc, "screen_walkthroughs");
  const usage = n(kc, "object_usage");
  const evidence = n(kc, "evidence_batches");
  const proposed = n(kc, "proposed_dispositions") + n(kc, "proposed_rules");
  if (rules) parts.push(`${rules} validated rule${rules === 1 ? "" : "s"}`);
  if (disp) parts.push(`${disp} validated disposition${disp === 1 ? "" : "s"}`);
  if (fields) parts.push(`${fields} field lineage summar${fields === 1 ? "y" : "ies"}`);
  if (screens) parts.push(`${screens} screen walkthrough${screens === 1 ? "" : "s"}`);
  if (usage) parts.push(`${usage} program usage summar${usage === 1 ? "y" : "ies"}`);
  if (evidence) parts.push(`${evidence} evidence batch${evidence === 1 ? "" : "es"}`);
  if (proposed) parts.push(`${proposed} proposed item${proposed === 1 ? "" : "s"} (labelled PROPOSED)`);
  const grounded = kc.used_validated
    ? `Grounded in ${parts.join(", ")}.`
    : parts.length
      ? `No validated consultant knowledge yet — prompt carried ${parts.join(", ")}.`
      : "No validated consultant knowledge or deterministic evidence was recorded for this workspace when it was generated.";
  const profileLabel = kc.profile && typeof kc.profile === "object" ? kc.profile.label || null : null;
  const hints = kc.hints && typeof kc.hints === "object"
    ? [...(kc.hints.programs || []), ...(kc.hints.files || []), ...(kc.hints.fields || [])]
    : [];
  return {
    note: KNOWLEDGE_NOTE,
    grounded,
    profileLabel,
    profileLine: profileLabel ? `Grounding profile: ${profileLabel}.` : null,
    hints,
    usedValidated: Boolean(kc.used_validated),
    truncated: Boolean(kc.truncated),
    includeUnvalidated: Boolean(kc.include_unvalidated),
  };
}

/** "Grounding profile: …" for the creation form, from the /deliverable-types entry. */
export function profileLineForType(type) {
  const label = type?.knowledge_profile?.label;
  return label ? `Grounding profile: ${label}.` : null;
}
